import { Component } from '@angular/core';
import { MaterialModule } from '../../../material/material.module';
import { Globals } from '../../../shared/models/globals';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import moment from 'moment/min/moment-with-locales';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { AppColorsService } from '../../../shared/services/app-colors.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { ChangePasswordDialogComponent } from './change-password-dialog/change-password-dialog.component';

@Component({
    selector: 'app-user-profile',
    imports: [CommonModule, FormsModule, MaterialModule, TranslateModule, MatSnackBarModule],
    templateUrl: './user-profile.component.html',
    styleUrl: './user-profile.component.css'
})
export class UserProfileComponent {

  language: string="";
  theme: string = "dark";

  constructor(public _globals: Globals, 
              private overlayContainer: OverlayContainer,
              private appColorsService: AppColorsService,
              private _router: Router, 
              private translate: TranslateService,
              private dialog: MatDialog,
              private snackBar: MatSnackBar ){
    this.language = translate.currentLang;

    //THeming
    this.theme = localStorage.getItem("theme")??"darkMode";
    this.changeTheme(this.theme);
    
    //console.log(translate.currentLang);
  }

  changeLanguage(value: string){
    //console.log(this.language.substring(0,2));
    //console.log(value);
    localStorage.setItem("language",this.language);
    this.translate.use(this.language);
    moment.locale(this.language.substring(0,1));
    this._globals.selectedLocale=this.language.substring(0,2);
  }

  changeTheme(value: string){
    //console.log(this.language.substring(0,2));
    //console.log(value);
    localStorage.setItem("theme",value);        
    this._globals.theme=value;
    this.overlayContainer.getContainerElement().classList.remove("darkMode");
    this.overlayContainer.getContainerElement().classList.remove("lightMode");
    this.overlayContainer.getContainerElement().classList.add(value + "Mode");
    document.body.classList.remove('dark-mode');
    document.body.classList.remove('light-mode');
    document.body.classList.add(value + '-mode');
    this.appColorsService.applyStoredThemeColors(value);
  }

  logout(){
    
    localStorage.removeItem('userToken');
    localStorage.removeItem('userRoles');
    localStorage.removeItem('Name');
    localStorage.removeItem('ToolbarColor');
    localStorage.removeItem('AppColors');
    localStorage.removeItem('isLoggedIn');
    this._globals.isLoggedIn=false;
    this._globals.toolbarBackgroundColor = "gray";
    localStorage.setItem('ToolbarColor', "gray");
    this._router.navigateByUrl('/login', {
         replaceUrl: true
    });
  }

  openChangePasswordDialog(): void {
    const dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
      width: '400px',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.snackBar.open(this.translate.instant('GENERAL.PASSWORDCHANGEDSUCCESS'), this.translate.instant('GENERAL.CLOSE'), {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom'
        });
      }
    });
  }
}
